import CryptoJS from "crypto-js";
// 密码加密设置
var getAesKey = localStorage.getItem("aesKey");
var getAesIv = localStorage.getItem("aesIv");
// AES 秘钥
var aesKey = getAesKey && getAesKey || '';
// AES-128-CBC偏移量
var aesIv = getAesIv && getAesIv || ''
// 秘密加密选项
var CBCOptions = {
  iv: CryptoJS.enc.Utf8.parse(aesIv),
  mode: CryptoJS.mode.CBC,
  padding: CryptoJS.pad.Pkcs7
}
export default {
  // // 加密
  // encrypt(word, keyStr, ivStr) {
  //   let aesIv = localStorage.getItem("aesIv");
  //   let aesKey = localStorage.getItem("aesKey");
  //   keyStr = aesKey ? aesKey : "";
  //   ivStr = aesIv ? aesIv : "";
  //   let key = CryptoJS.enc.Utf8.parse(keyStr);
  //   let iv = CryptoJS.enc.Utf8.parse(ivStr);
  //   let srcs = CryptoJS.enc.Utf8.parse(word);

  //   let encrypted = CryptoJS.AES.encrypt(srcs, key, {
  //     iv,
  //     mode: CryptoJS.mode.CBC,
  //     padding: CryptoJS.pad.ZeroPadding
  //   });
  //   return encrypted.toString();
  // },
  // // 解密
  // decrypt(word, keyStr, ivStr) {
  //   let aesIv = localStorage.getItem("aesIv");
  //   let aesKey = localStorage.getItem("aesKey");
  //   keyStr = aesKey ? aesKey : "";
  //   ivStr = aesIv ? aesIv : "";
  //   var key = CryptoJS.enc.Utf8.parse(keyStr);
  //   let iv = CryptoJS.enc.Utf8.parse(ivStr);

  //   var decrypt = CryptoJS.AES.decrypt(word, key, {
  //     iv,
  //     mode: CryptoJS.mode.CBC,
  //     padding: CryptoJS.pad.ZeroPadding
  //   });
  //   return decrypt.toString(CryptoJS.enc.Utf8);
  // }


  encrypt(data) {
    var key = CryptoJS.enc.Utf8.parse(aesKey);
    var secretData = CryptoJS.enc.Utf8.parse(data);
    var encrypted = CryptoJS.AES.encrypt(
      secretData,
      key,
      CBCOptions
    );
    return encrypted.toString();
  },
  decrypt(data) {
    var key = CryptoJS.enc.Utf8.parse(aesKey);
    var decrypt = CryptoJS.AES.decrypt(
      data,
      key,
      CBCOptions
    );
    // return CryptoJS.enc.Utf8.stringify(decrypt).toString();
    let decryptData = CryptoJS.enc.Utf8.stringify(decrypt).toString();
    return decryptData.replace(/\0/g, "");
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/crypto.js